import axios from 'axios';
import qs from 'qs';
import api from './api';
import urlExt from '@w/utils/url';
import logger from '@w/utils/logger';
import { hybrid } from '@kd/hybrid';
import Generate from '@/widgets/utils/generate';
import { inApp } from '@w/utils/system';
const isProd = process.env.NODE_ENV === 'production';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response); // eslint-disable-line
    }
  },
  error => {
    return Promise.reject(error.response);
  }
);

/**
 * 响应处理
 */
function responseHandler(response = {}) {
  const { errNo } = response;
  if (typeof errNo !== 'undefined') {
    switch (Number(errNo)) {
      case 0:
        return response;
      case 3:
      case 13:
        hybrid('login'); // eslint-disable-line
        break;
      default:
        return Promise.reject(response); // eslint-disable-line
    }
  }
}

const cuid = urlExt.getQuery('cuid');

/* eslint-disable no-new-func */
const http = new Function();
['get', 'post'].forEach(method => {
  http[method] = async function (url, params = {}, options) {
    const base = { method: method, url: !isProd ? '/api' + url : url };
    // 是否需要加密
    if (params.isNeedEncryption) {
      const g = new Generate(params);
      params = { fkey: g.fkey, ftime: g.ftime, ...params };
    }
    params = Object.assign({}, params);
    method === 'get' && (base.params = params);
    method === 'post' && (base.data = qs.stringify(params));
    try {
      const response = await axios(Object.assign(base, options));
      return responseHandler(response.data);
    } catch (error) {
      console.log('未知错误'); // eslint-disable-line
      return Promise.reject(new Error('请求失败'));
    }
  };
});

/**
 *  端内加密 请求封装
 */
async function deRequest(url, params) {
  if (!inApp) {
    return http.post(url, params);
  }
  // 解决安卓无参数调decode_httpRequest报错问题
  if (!params || JSON.stringify(params) === '{}') {
    params = { notEmptyForAndrod: '1' };
  }
  try {
    let result = null; // eslint-disable-line
    await new Promise(resolve => hybrid('decode_httpRequest', { url, params, shouldDecode: 1 }, resolve)) //  eslint-disable-line
      .then(res => {
        // eslint-disable-line
        try {
          if (res) {
            console.log(res);
            try {
              res.data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
            } catch (e) {
              console.log(e);
            }
            result = responseHandler(res);
          } else {
            result = Promise.reject(new Error('请求失败'));
          }
        } catch (e) {
          console.log('未知错误', e); //  eslint-disable-line
          result = Promise.reject(new Error('请求失败'));
        }
      });
    return result;
  } catch (error) {
    console.log('未知错误'); //  eslint-disable-line
    return Promise.reject(new Error('请求失败'));
  }
}

export const $get = http['get'];
export const $post = http['post'];
export const $deHttp = deRequest;

export default {
  install(Vue) {
    function _hybrid(...args) {
      try {
        console.log(args);
        hybrid(...args);
      } catch (e) {
        console.log('[action error]', e);
      }
    }
    Vue.$http = Vue.prototype.$http = {
      get: $get,
      post: $post,
      entry: $deHttp
    };
    Vue.api = Vue.prototype.api = api;
    Vue.cuid = Vue.prototype.cuid = Array.isArray(cuid) ? cuid[0] : cuid;
    Vue.hybrid = Vue.prototype.hybrid = _hybrid; // eslint-disable-line
    Vue.logger = Vue.prototype.logger = logger;
  }
};
